exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-nav[data-v-23d1f16c]{padding-left:5%;padding-right:5%}.detail-title-1[data-v-23d1f16c]{margin-bottom:0.16rem}.detail-title-2[data-v-23d1f16c]{margin-top:0.4rem}.unit[data-v-23d1f16c]{font-size:0.18rem;font-weight:400;color:#929dad;margin-left:0.04rem}\n", ""]);

// exports
